import React, { useState, useEffect } from "react";
import axios from "axios";
import "../CSS/ServicesContent.css";

const ServicesContent = () => {
  const [categories, setCategories] = useState([]);
  const [services, setServices] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [holdTimeout, setHoldTimeout] = useState(null);

  useEffect(() => {
    fetchServiceData();
  }, []);

  const fetchServiceData = async () => {
    try {
      const response = await axios.get("https://us-central1-janushreebeautyparlour.cloudfunctions.net/api/getServicesContent1");
      const data = response.data ? Object.values(response.data) : [];
      setServices(data);
      setCategories(data.map((service) => service.title)); // Extract titles for tabs
    } catch (error) {
      console.error("Error fetching service data:", error);
    }
  };

  const handleCategoryClick = (index) => {
    setActiveIndex(index);
    clearTimeout(holdTimeout);
    setHoldTimeout(
      setTimeout(() => {
        setActiveIndex((prevIndex) => (prevIndex + 1) % categories.length);
      }, 20000)
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % categories.length);
    }, 18000);

    return () => clearInterval(interval);
  }, [categories.length]);

  const activeCategory = categories[activeIndex];
  const activeService = services.find((service) => service.title === activeCategory);

  const isMobile = window.innerWidth <= 768;

  return (
    <div className="ftco-section" style={{backgroundColor:"black"}}>
      <div className="container">
        <div className="row justify-content-center pb-5">
          <div className="col-md-7 text-center heading-section ftco-animate">
            <h2 className="mb-2 blackthemegradient">
              Our Specialization Service
            </h2>
            <p style={{textAlign: "justify"}}>
              Our team of experienced therapists utilizes cutting-edge techniques and personalized
              treatment plans to address your unique needs.
            </p>
          </div>
        </div>
        <div className="container">
       <div id="tabs" className="mb-4 tabs-container" style={{ flexDirection: isMobile ? "column" : "row" }}>
       {categories.map((category, index) => {
                return (
                  <div
                    key={index}
                    className={`tab-container ${index === 4 || index === 5 ? "special-tab" : ""}`}
                    style={{
                      display: isMobile ? "block" : "inline-block",
                      width: isMobile ? "100%" : "22%",
                    }}
                  >
                    <div
                      className={`tab tabts ${index === activeIndex ? "active" : ""}`}
                      onClick={() => handleCategoryClick(index)}
                      style={{
                        cursor: "pointer",
                        padding: "10px 20px",
                        margin: "5px",
                        backgroundColor: index === activeIndex ? "#853f91" : "white",
                        color: index === activeIndex ? "#fff" : "#000",
                        textAlign: "center",
                        width: isMobile ? "auto" : "220px",
                      }}
                    >
                      {category}
                    </div>
                  </div>
                );
              })}
          </div>

          

          <div id="content">
            {activeService && (
              <div className="row">
                {activeService.subtitles2.map((item) => (
                  <div key={item.subtitle_id} className="col-md-3 d-flex align-self-stretch ftco-animate">
                    <div className="media block-6 servicesdisplaycontent d-block text-center">
                      <div className="icon d-flex justify-content-center align-items-center">
                        <img src={item.subimage} alt={item.subtitle} className="service-icon" />
                      </div>
                      <div className="media-body p-2 mt-3">
                        <h3 className="heading blackthemegradient">{item.subtitle}</h3>
                        <p className="text-justify" style={{ textAlign: "justify" }}>
                          {item.subdescription}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesContent;
